/*
 *
 * Survey constants
 *
 */

const scope = 'app/Survey';

// ACTION TYPE CONSTANTS
export const FETCH_SURVEY = `${scope}/FETCH_SURVEY`;
export const FETCH_SURVEY_SUCCESS = `${scope}/FETCH_SURVEY_SUCCESS`;
export const FETCH_SURVEY_ERROR = `${scope}/FETCH_SURVEY_ERROR`;
export const STORE_SURVEY = `${scope}/STORE_SURVEY`;
export const STORE_SURVEY_SUCCESS = `${scope}/STORE_SURVEY_SUCCESS`;
export const STORE_SURVEY_ERROR = `${scope}/STORE_SURVEY_ERROR`;

export const UPDATE_SURVEY = `${scope}/UPDATE_SURVEY`;
export const UPDATE_SURVEY_SUCCESS = `${scope}/UPDATE_SURVEY_SUCCESS`;
export const UPDATE_SURVEY_ERROR = `${scope}/UPDATE_SURVEY_ERROR`;
export const UPDATE_SURVEY_COMPLETES = `${scope}/UPDATE_SURVEY_COMPLETES`;

export const UPDATE_IR = `${scope}/UPDATE_IR`;
export const UPDATE_IR_SUCCESS = `${scope}/UPDATE_IR_SUCCESS`;
export const UPDATE_IR_ERROR = `${scope}/UPDATE_IR_ERROR`;

export const DELETE_IR = `${scope}/DELETE_IR`;
export const DELETE_IR_SUCCESS = `${scope}/DELETE_IR_SUCCESS`;
export const DELETE_IR_ERROR = `${scope}/DELETE_IR_ERROR`;

export const RENAME_SURVEY = `${scope}/RENAME_SURVEY`;
export const RENAME_SURVEY_SUCCESS = `${scope}/RENAME_SURVEY_SUCCESS`;
export const RENAME_SURVEY_ERROR = `${scope}/RENAME_SURVEY_ERROR`;

export const UPDATE_SURVEY_NAME_TERMS = `${scope}/UPDATE_SURVEY_NAME_TERMS`;
export const UPDATE_SURVEY_NAME_TERMS_SUCCESS = `${scope}/UPDATE_SURVEY_NAME_TERMS_SUCCESS`;
export const UPDATE_SURVEY_NAME_TERMS_ERROR = `${scope}/UPDATE_SURVEY_NAME_TERMS_ERROR`;

export const SET_SURVEY_CONFIG = `${scope}/SET_SURVEY_CONFIG`;

// SURVEY TYPE CONSTANTS
export const SURVEY_TYPE_REGULAR = 'regular';
export const SURVEY_TYPE_THIRD_PARTY = 'thirdParty';
export const SURVEY_TYPE_INTERNAL = 'internal';
export const SURVEY_TYPE_DISTRIBUTION_LINK = 'distributionLink';
export const SURVEY_TYPE_PEEQ = 'peeq';

// SURVEY CONFIG CONSTANTS
export const SURVEY_CONFIG_PAYMENT_TYPE_PREPAID = 'prepaid';
export const SURVEY_CONFIG_PAYMENT_TYPE_INVOICED = 'invoiced';
export const SURVEY_CONFIG_PRICING_TYPE_REAL_TIME = 'real-time';
export const SURVEY_CONFIG_PRICING_TYPE_FIXED_PRICING = 'fixed-pricing';
export const SURVEY_CONFIG_PRICING_TYPE_NO_PRICING = 'no-pricing';

// PEEQ SURVEY CATEGORY TYPE CONSTANTS
export const PEEQ_CATEGORY_TYPE_INVOICED = 'invoiced';
export const PEEQ_CATEGORY_TYPE_PREPAID = 'prepaid';

export const SURVEY_EXTENDED_FORMAT = 'extended';

export const AI_REPORT_SOURCE_ENUM = {
  MY_SURVEYS: 'mysurveys',
  SUMMARY: 'summary',
  RESULTS: 'results',
};

export const AI_REPORT_USER_ENUM = {
  GUEST: 'guest',
};
